module.exports = __webpack_public_path__ + "img/6.9af2a1df.jpg";